import { useQuery } from '@tanstack/react-query'
import { Link, createFileRoute } from '@tanstack/react-router'
import { Archive } from 'lucide-react'
import { useDeferredValue, useState } from 'react'
import { projectsQuery } from '@/api/queries'
import { Badge } from '@/components/ui/badge'
import { EmptyState } from '@/components/ui/empty-state'
import { Input } from '@/components/ui/field'
import { formatDay, formatZar } from '@/lib/format'
import { COMMERCIAL_STAGE, DESIGN_STATUS } from '@/lib/status'

/** Projects archive. Reps see their own; Cam, Mo and Raees see everything. */
export const Route = createFileRoute('/_app/projects')({ component: Projects })

function Projects() {
  const [q, setQ] = useState('')
  const deferred = useDeferredValue(q)
  const { data, isLoading } = useQuery(projectsQuery(deferred.trim()))
  return (
    <div className="mx-auto flex max-w-5xl flex-col gap-6">
      <h1 className="text-3xl uppercase">Projects</h1>
      <Input
        aria-label="Search projects"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Search by name, ref, suburb or address"
      />
      {isLoading && <p className="text-fg-muted">Loading...</p>}
      {!isLoading && (data?.length ?? 0) === 0 && (
        <EmptyState icon={Archive} title="No projects found" />
      )}
      <ul className="flex flex-col gap-2">
        {(data ?? []).map((p) => (
          <li key={p.id}>
            {p.latest ? (
              <Link
                to="/reluxes/$reluxId"
                params={{ reluxId: p.latest.id }}
                className="flex flex-wrap items-center gap-3 rounded-card border border-border bg-surface p-4 hover:bg-surface-2"
              >
                <div className="min-w-0 flex-1">
                  <p className="font-semibold">{p.name}</p>
                  <p className="text-sm text-fg-muted">
                    {[p.ref, p.owner_name, p.site_suburb, p.application, formatDay(p.created_at)]
                      .filter(Boolean)
                      .join(' - ')}
                  </p>
                </div>
                <Badge tone={DESIGN_STATUS[p.latest.status].tone}>
                  Rev {p.latest.revision} {DESIGN_STATUS[p.latest.status].label}
                </Badge>
                <Badge tone={COMMERCIAL_STAGE[p.commercial_stage].tone}>
                  {COMMERCIAL_STAGE[p.commercial_stage].label}
                </Badge>
                {p.won_value_zar != null && (
                  <Badge tone="brand">{formatZar(p.won_value_zar)}</Badge>
                )}
              </Link>
            ) : null}
          </li>
        ))}
      </ul>
    </div>
  )
}
